<template>
  <div>
    <swiper :options="swiperOption" class="swiper">
      <swiper-slide
        v-for="(data, idx) in image"
        :key="idx"
        :class="slide()"
        :style="{ 'backgroundImage': `url(${data})` }" >
      </swiper-slide>
      <div class="swiper-pagination"  slot="pagination"></div>
    </swiper>
    <div class="notice_box" v-if="stampDataNew.mingle_badge_type_desc">
      <div class="notice">Notice</div>
      <div class="txt">
        {{ stampDataNew.mingle_badge_type_desc }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'StampSwiper',
  props: {
    image: Array
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        }
      }
    }
  },
  computed: {
    ...mapState(['stampDataNew'])
  },
  methods: {
    slide () {
      return (this.stampDataNew.tour_image) ? 'slide' : 'slidePoi'
    }
  }
}
</script>
<style scoped>
    .swiper {
        width:100%;
        position: relative;
    }
    .swiper .slide {
        width:100%;
        height: 55vw;
        max-height: 320px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        z-index: 100;
    }
    .swiper .slidePoi {
        width:100%;
        height: 55vw;
        max-height: 320px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        z-index: 100;
    }
    .swiper-pagination {
        width:40px;
        height:20px;
        line-height:20px;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 10px;
        font-size: 11px;
        color: #fff;
        font-family: inaviM;
        text-align: center;
        position: absolute;
        bottom: 11px;
        right: 12px;
        left: auto;
    }
</style>
